



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import DescBlock from '../../block';

@Component({
  components: {
    DescBlock,
  },
})
export default class ComponentsPartsCatalogCardComponentsTabsDescription extends Vue {
  // Props
  @Prop({ type: String, default: '' })
  description: string;

  @Prop({ type: String, default: '' })
  announce: string;

  @Prop({ type: String, default: '' })
  length: string;

  @Prop({ type: String, default: '' })
  teachers: string;

  @Prop({ type: String, default: '' })
  educationPlan: string;

  @Prop({ type: String, default: '' })
  expectedResults: string;

  @Prop({ type: String, default: '' })
  scheduleDescription: string;

  @Prop({ type: String, default: '' })
  priceDescription: string;

  @Prop({ type: String, default: '' })
  programTarget: string;

  @Prop({ type: String, default: '' })
  educationForm: string;

  @Prop({ type: String, default: '' })
  specialConditions: string;

  @Prop({ type: String, default: '' })
  materialBase: string;

  @Prop({ type: String, default: '' })
  educationBase: string;

  @Prop({ type: Array, default: () => [] })
  video: Array<string>;

  @Prop({ type: String, default: '' })
  seoFooter: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/tabs/description/Description.vue